export default __webpack_public_path__ + "static/media/AE.dcefe088.svg";